import { render, staticRenderFns } from "./KusBaseTest.vue?vue&type=template&id=7c84ae6b"
import script from "./KusBaseTest.vue?vue&type=script&lang=js"
export * from "./KusBaseTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports